import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const MarkupIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 24 24">
      <g transform="translate(12, 12) scale(1.2) translate(-12, -12)">
        <path d="M16.9229 10H15.9229V7H7V15.9229H10.1211V16.9229H6V6H16.9229V10Z" fill="currentColor" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18 15.4286H15.4286V18H14.5714V15.4286H12V14.5714H14.5714V12H15.4286V14.5714H18V15.4286Z"
          fill="currentColor"
          stroke="currentColor"
        />
      </g>
    </SvgIcon>
  );
};

export default MarkupIcon;
